import { getMultiselectValue, getVisibility } from "@client/lib/settings";
import {
  createShallowEqualSelector,
  getLayoutColorSelector,
  getLayoutSettingValueSelector,
  getSettingValueSelector,
  makeLogoOptionsSelector,
  screenSelector,
  TargetSelector
} from "@client/selectors";
import { type AppState, type ElementVisibility, ScreenType } from "@client/types";
import * as React from "react";
import { createSelector } from "reselect";

export const logoOptionsSelector = makeLogoOptionsSelector(TargetSelector.Layout, "sidePanel");

const elementsSidePanelSelector = getSettingValueSelector(TargetSelector.Layout, "sidePanel", "elements");
export const visibilitySelector = createSelector(
  [elementsSidePanelSelector],
  (isVisible): ElementVisibility => getVisibility(isVisible)
);

const sidePanelElementsShowHideSelector = getLayoutSettingValueSelector("elements", "sidePanel", getMultiselectValue);
const getSidePanelElementIsVisibleSelector = (element: "copyright" | "login" | "register") =>
  createSelector([sidePanelElementsShowHideSelector], (showHide): boolean => (showHide ?? []).includes(element));

export const isCopyrightVisibleSelector = getSidePanelElementIsVisibleSelector("copyright");
export const isLoginVisibleSelector = getSidePanelElementIsVisibleSelector("login");
export const isRegisterVisibleSelector = getSidePanelElementIsVisibleSelector("register");

export const sidePanelAppearanceSelector = getLayoutSettingValueSelector("appearance", "sidePanel");
export const sidePanelPositionSelector = getLayoutSettingValueSelector("position", "sidePanel");

export const isSidePanelToggledSelector = (state: AppState) => state.widgets.sidePanel.isToggled;

export const isSidePanelStaticSelector = createSelector(
  [sidePanelAppearanceSelector],
  (appearance) => appearance === "side-panel-static"
);
export const sidePanelColorOptionsSelector = getLayoutSettingValueSelector("colorType", "sidePanel");
export const sidePanelBackColorSelector = getLayoutColorSelector("backColor", "sidePanel");
export const sidePanelTextColorSelector = getLayoutColorSelector("textColor", "sidePanel");
export const contentStyleSelector = createShallowEqualSelector(
  [sidePanelColorOptionsSelector, sidePanelBackColorSelector],
  (colorOptions, backColor): React.CSSProperties => ({
    backgroundColor: colorOptions === "wsc-sidepanel-custom" ? backColor : undefined
  })
);
export const styleSelector = createShallowEqualSelector(
  [isSidePanelStaticSelector, screenSelector],
  (isStatic, screen): React.CSSProperties => ({
    position: screen === ScreenType.Desktop && isStatic ? "sticky" : "fixed"
  })
);
